export const CHART_COLORS = {
  cambridge: '#6AA197',
  pear: '#C0D11C',
  muted: '#A39D97',
  mutedLight: '#CFCEC9',
  grid: '#EFEDE4'
};

/**
 * Shared options of the dashboard column charts (@ant-design/charts v2).
 * @param {Object} params - Parameters.
 * @param {number} params.height - Height of the chart.
 * @returns {Object} - Base configuration object.
 */
export const baseColumnConfig = ({ height = 260 } = {}) => ({
  height,
  autoFit: true,
  axis: {
    x: {
      labelAutoHide: false,
      labelAutoRotate: false,
      labelFontSize: 11,
      line: false
    },
    y: { gridStroke: CHART_COLORS.grid, gridLineWidth: 1, title: false }
  },
  legend: {
    color: {
      position: 'top',
      layout: { justifyContent: 'flex-end' }
    }
  }
});

/**
 * Options of a column chart split in several series.
 * @param {Object} params - Parameters.
 * @param {string[]} params.domain - Series names, in display order.
 * @param {string[]} params.colors - Colors matching `domain`.
 * @param {boolean} params.stack - Stack the series instead of grouping them.
 * @returns {Object} - Series configuration object.
 */
export const seriesColumnConfig = ({ domain, colors, stack = false }) => ({
  ...baseColumnConfig(),
  colorField: 'type',
  scale: { color: { domain, range: colors } },
  [stack ? 'stack' : 'group']: true,
  style: { radiusTopLeft: 4, radiusTopRight: 4, maxWidth: 28 }
});
